export default [
    {
        platformName: 'akucun-saas-pay',
        shortName: 'pay', // 对应了.env.xxx配置的子应用入口
        cname: '结算' // 子应用域的描述
    },
    {
        platformName: 'akucun-saas-merchant',
        shortName: 'merchant',
        cname: '商家'
    },
    {
        platformName: 'akucun-saas-order',
        shortName: 'order',
        cname: '订单'
    },
    {
        platformName: 'akucun-saas-marketing',
        shortName: 'marketing',
        cname: '营销'
    },
    {
        platformName: 'saas-shop-decorate',
        shortName: 'decorate',
        cname: '店铺装修'
    },
    {
        platformName: 'aikucun-dc-saas-ui',
        shortName: 'bidc',
        cname: 'bi百宝箱'
    },
    {
        platformName: 'aikucun-mx-decorate-ui',
        shortName: 'mxDecorate',
        cname: '店铺装修'
    },
    {
        platformName: 'mx-merchant-web',
        shortName: 'mx-merchant-web',
        cname: 'mx-merchant-web'
    }
];
